import { z } from 'zod';
import { shiftWithAnalyticsAndMissionSchema } from './shiftCommonSchema';
const getFilteredUpcomingShiftsRequestSchema = z.object({
    isVolunteerView: z.boolean(),
});
const getFilteredUpcomingShiftsResponseSchema = shiftWithAnalyticsAndMissionSchema.merge(z.object({
    missionType: z.string().trim().min(1),
}));
const partialGetFilteredUpcomingShiftsResponseSchema = getFilteredUpcomingShiftsResponseSchema.omit({
    columns: true,
});
export const getFilteredUpcomingShiftsFunctionDef = {
    name: 'getFilteredUpcomingShifts',
    requestSchema: getFilteredUpcomingShiftsRequestSchema,
    responseSchema: getFilteredUpcomingShiftsResponseSchema.array(),
};
